import React from 'react';

const Header = () => {
    return(
        <div className="nav justify-content-center">            
            <div className="col-6 border-bottom">
                <h1 className="d-flex justify-content-center display-4">
                    Lista de tareas
                </h1>                
            </div>
        </div>
    )
}

export default Header;